define( function() {
	"use strict";

	return ( /\?/ );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/ajax/var/rquery.js
// module id = QSv/
// module chunks = 0 1